import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { authState } from "@atoms/authState";
import { getUserBaseRoute } from "@utils/auth";

/**
 * NotFound - Page 404 qui redirige automatiquement vers l'espace de l'utilisateur
 * ou affiche un message d'erreur si non connecté.
 */
const NotFound = () => {
  const authValue = useRecoilValue(authState);
  const navigate = useNavigate();

  useEffect(() => {
    if (authValue?.user) {
      const userSpace = getUserBaseRoute(authValue);
      if (userSpace) {
        navigate(`/${userSpace}/dashboard`, { replace: true });
      } else {
        navigate("/connexion", { replace: true });
      }
    }
  }, [authValue, navigate]);

  const handleRedirect = () => {
    if (authValue?.user) {
      const userSpace = getUserBaseRoute(authValue);
      if (userSpace) {
        navigate(`/${userSpace}/dashboard`, { replace: true });
      } else {
        navigate("/connexion", { replace: true });
      }
    } else {
      navigate("/connexion", { replace: true });
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        padding: "2rem",
      }}
    >
      <h1 style={{ fontSize: "4rem", marginBottom: "1rem", color: "#ccc" }}>
        404
      </h1>
      <h2 style={{ marginBottom: "1rem" }}>Page non trouvée</h2>
      <p style={{ marginBottom: "2rem", color: "#666" }}>
        L'URL que vous avez saisie ne correspond à aucune page.
      </p>
      <button
        onClick={handleRedirect}
        style={{
          padding: "0.75rem 1.5rem",
          fontSize: "1rem",
          cursor: "pointer",
          backgroundColor: "#2185d0",
          color: "white",
          border: "none",
          borderRadius: "4px",
        }}
      >
        {authValue?.user ? "Retour au tableau de bord" : "Aller à la connexion"}
      </button>
    </div>
  );
};

export default NotFound;
